import { readClipboardImage, readClipboardImageFromEvent } from '@wapharma/shared';

export function acceptAllowsFile(accept: string | undefined, file: File): boolean {
  const tokens = String(accept ?? '')
    .split(',')
    .map((t) => t.trim().toLowerCase())
    .filter(Boolean);
  if (tokens.length === 0) return true;
  const mime = String(file.type ?? '').toLowerCase();
  const name = String(file.name ?? '').toLowerCase();
  return tokens.some((token) => {
    if (token.startsWith('.')) return name.endsWith(token);
    if (token.endsWith('/*')) return mime.startsWith(token.slice(0, -1));
    return mime === token;
  });
}

export function acceptAllowsImagePaste(accept: string | undefined): boolean {
  const raw = String(accept ?? '').toLowerCase();
  if (!raw) return true;
  return raw.includes('image/') || raw.includes('.png') || raw.includes('.jpe') || raw.includes('.webp') || raw.includes('.gif') || raw.includes('.avif');
}

export function isEditablePasteTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (tag === 'INPUT') {
    const type = (target as HTMLInputElement).type;
    return type !== 'file' && type !== 'button' && type !== 'submit' && type !== 'checkbox' && type !== 'radio' && type !== 'hidden' && type !== 'reset';
  }
  return Boolean(target.closest('textarea, select, input:not([type="file"]), [contenteditable="true"]'));
}

export function fileFromClipboardEvent(event: ClipboardEvent, accept?: string): File | null {
  const file = readClipboardImageFromEvent(event);
  if (!file) return null;
  if (!acceptAllowsFile(accept, file)) return null;
  return file;
}

export async function fileFromClipboard(accept?: string): Promise<File | null> {
  const file = await readClipboardImage();
  if (!file) return null;
  if (!acceptAllowsFile(accept, file)) return null;
  return file;
}

export function assignFilesToInput(input: HTMLInputElement, files: File[]): boolean {
  try {
    const dt = new DataTransfer();
    for (const file of files) dt.items.add(file);
    input.files = dt.files;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  } catch {
    return false;
  }
}
